import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'
import { useIntl } from 'react-intl'

const formatBold = (chunks: React.ReactNode) => <b>{chunks}</b>

interface Props {
  start: string
  end: string
}

function SearchTileRowOverlineJourney({ start, end }: Props) {
  const intl = useIntl()
  const roundTrip = start === end

  const journeyMessage = roundTrip
    ? intl.formatMessage(
        {
          id: 'z0dNwNVtLP',
          defaultMessage: 'Starts and ends in <b>{start}</b>',
          description: 'Round trip journey description showing start location on search tile',
        },
        { start, b: formatBold },
      )
    : intl.formatMessage(
        {
          id: 'eEoihG35O/',
          defaultMessage: 'Starts in <b>{start}</b>, ends in <b>{end}</b>',
          description: 'One-way journey description showing start and end locations on search tile',
        },
        { start, end, b: formatBold },
      )

  return <BodyText variant="small" colour="neutral-two">
    {journeyMessage}
  </BodyText>
}

export default SearchTileRowOverlineJourney
